import SiteNav from "./components/SiteNav";
import Hero from "./components/Hero";
import QuickEntry from "./components/QuickEntry";
import LineStatus from "./components/LineStatus";
import DeviceCompare from "./components/DeviceCompare";
import GenreTypes from "./components/GenreTypes";
import TitleCatalog from "./components/TitleCatalog";
import FaqSection from "./components/FaqSection";
import SafetyTips from "./components/SafetyTips";
import UpdateLog from "./components/UpdateLog";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNav />
      <main>
        <Hero />
        <QuickEntry />
        <LineStatus />
        <DeviceCompare />
        <GenreTypes />
        <TitleCatalog />
        <FaqSection />
        <SafetyTips />
        <UpdateLog />
      </main>
      <SiteFooter />
    </div>
  );
}